import { useEffect } from 'react';
import { useUpdateStore, useDialogStore, useTranslation, selectUpdateAvailable } from '../store';
import { SettingsDialog } from './dialogs/SettingsDialog';
import toastService from '../services/toastService';

const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
const UPDATE_TOAST_DURATION_MS = 20000;

// Silently checks for a new deployed version in the background and, when one
// is found, nudges the user with a toast instead of relying on them to open
// Settings on their own. The actual update still only happens from the
// Settings dialog - this just tells people it's there.
const UpdateNotifier = () => {
  const { t } = useTranslation();
  const { openDialog } = useDialogStore();
  const remoteVersion = useUpdateStore((state) => state.remoteVersion);
  const notifiedVersion = useUpdateStore((state) => state.notifiedVersion);
  const updateAvailable = useUpdateStore(selectUpdateAvailable);
  const loadLocalVersion = useUpdateStore((state) => state.loadLocalVersion);
  const checkForUpdate = useUpdateStore((state) => state.checkForUpdate);
  const markNotified = useUpdateStore((state) => state.markNotified);

  useEffect(() => {
    loadLocalVersion();
    checkForUpdate();

    const interval = setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [loadLocalVersion, checkForUpdate]);

  useEffect(() => {
    if (!updateAvailable || remoteVersion === notifiedVersion) return;

    markNotified(remoteVersion);
    toastService.info(t('updateAvailableToast'), {
      force: true,
      duration: UPDATE_TOAST_DURATION_MS,
      onClick: () => openDialog(SettingsDialog, {}),
    });
  }, [updateAvailable, remoteVersion, notifiedVersion, t, openDialog, markNotified]);

  return null;
};

export default UpdateNotifier;
